import { Box, Grid, Typography } from "@mui/material";
import { formatAmount } from "../utils/helpers";

export type ToolingDetails = {
  seriesName: string;
  runningTotal: number;
  totalBudget: number;
};

type Props = {
  toolingDetails: ToolingDetails;
};

const ToolingInformation = (props: Props) => {

  const {
    toolingDetails
  } = props;

  return (
    <div style={{ marginTop: "20px" }}>
      <Box className="custom-box">
        <Typography variant="h6" sx={{ marginLeft: "5px", marginBottom: "30px" }}>Tooling</Typography>
        <Grid container sx={{ marginLeft: 0, gap: "10px" }}>
          {toolingDetails?.totalBudget ? <>
              <Box className="child-box">
                <Typography sx={{ marginLeft: "5px", marginBottom: "10px" }}>
                  <span>Tooling Running Total:</span>
                  <span style={{
                    fontWeight: 500, marginLeft: "15px", 
                    color: toolingDetails?.runningTotal > toolingDetails?.totalBudget ? "red" : "inherit" 
                  }}>
                    {`${formatAmount(toolingDetails?.runningTotal || 0, "USD")}`}
                  </span>
                </Typography>
              </Box>
              <Box className="child-box">
                <Typography sx={{ marginLeft: "5px", marginBottom: "10px" }}>
                  <span>Tooling Budget:</span>
                  <span style={{fontWeight: 500, marginLeft: "15px" }}>
                    {`${formatAmount(toolingDetails?.totalBudget, "USD")}`}
                  </span>
                </Typography>
              </Box>
            </> :
            <Typography sx={{ marginLeft: "5px", marginBottom: "10px", color: "#ff0000" }}>{`Tooling budget is not set for series name "${toolingDetails?.seriesName}".`}</Typography>
          }
        </Grid>
      </Box>
    </div>
  )
}

export default ToolingInformation;